export default __webpack_public_path__ + "/dist/images/rating.94fc770639d8a63e025c094062d59c45.svg";